import { render } from "./AalLetterGeneration.vue?vue&type=template&id=1f5be74e"
import script from "./AalLetterGeneration.vue?vue&type=script&lang=js"
export * from "./AalLetterGeneration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__